import TableWithTitle from '@/components/TableWithTitle.vue';
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import { getDescriptionBasedOnKpiKey, getColorsBasedOnRange } from "@/utils/transformers";
import { SELECTOR, PERIOD_FIELD, SEARCHES_FIELD, BRAND_IMPRESSION_SHARE_FIELD, BRAND_IMPRESSION_FIELD, BRAND_CLICK_SHARE_FIELD, BRAND_CLICK_FIELD, BRAND_PURCHASE_SHARE_FIELD, BRAND_PURCHASE_FIELD, SEARCH_FUNNEL_CVR_FIELD, SEARCH_FUNNEL_CTR_FIELD, SEARCH_SHARE_OF_REVENUE_FIELD, SELLER_NOTORIETY_FIELD } from "@/utils/table_fields";
import AppIcon from '@/components/AppIcon.vue';
import { mapState } from "vuex";
import { HugValue, DateValue, CurrencyValue, NumberValue, PercentageValue, OverlapBarValue, BoxedValue, BarWithValue, DotElement } from "@/components/tableElements";
import LiteTableMixin from '@/mixins/LiteTableMixin.vue';
import { DEFAULT_DATE_FORMATS, PERIOD_COLUMN_TITLES, SEARCH_FUNNEL_CTR_HEATMAP_COLORS, SEARCH_FUNNEL_CVR_HEATMAP_COLORS } from '@/utils/constants';
import FlexRow from '@/components/FlexRow.vue';
import moment from 'moment';
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import WrapTableWithShowMore from '@/components/WrapTableWithShowMore.vue';
export default {
  name: "PeriodTable",
  components: {
    HugValue,
    DateValue,
    CurrencyValue,
    NumberValue,
    PercentageValue,
    OverlapBarValue,
    FlexRow,
    SlotWithEvolutionValue,
    EvolutionValue,
    WrapTableWithShowMore,
    TableWithTitle,
    WrapWithPopover,
    AppIcon,
    BoxedValue,
    BarWithValue,
    DotElement
  },
  mixins: [LiteTableMixin],
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },
  emits: ["setDateRange", "refresh"],
  data() {
    return {
      PERIOD_COLUMN_TITLES,
      SEARCH_FUNNEL_CTR_HEATMAP_COLORS,
      SEARCH_FUNNEL_CVR_HEATMAP_COLORS,
      evolCategory: {
        prev_period: "_vs_previous_period",
        same_period_ly: "_vs_previous_year"
      }
    };
  },
  computed: {
    ...mapState({
      periodTable: state => state.search_funnel.periodTable,
      tab: state => state.search_funnel.currentTabValue,
      period: state => state.search_funnel.period,
      currentPeriod: state => state.search_funnel.currentPeriod,
      periodCategory: state => state.search_funnel.periodCategory,
      targetings: state => state.search_funnel.targetings,
      targeting_types: state => state.search_funnel.targeting_types
    }),
    fields() {
      return [SELECTOR, PERIOD_FIELD, SEARCH_SHARE_OF_REVENUE_FIELD, this.targetings?.selectedValues.length || this.targeting_types?.selectedValues.length ? SEARCHES_FIELD : SELLER_NOTORIETY_FIELD, BRAND_IMPRESSION_FIELD, SEARCH_FUNNEL_CTR_FIELD, BRAND_CLICK_FIELD, SEARCH_FUNNEL_CVR_FIELD, BRAND_PURCHASE_FIELD, BRAND_IMPRESSION_SHARE_FIELD, BRAND_CLICK_SHARE_FIELD, BRAND_PURCHASE_SHARE_FIELD];
    },
    items() {
      return this.periodTable[this.tab].items;
    },
    maxCharCount() {
      return this.periodTable[this.tab].maxCharCount;
    },
    minMax() {
      return this.periodTable[this.tab].minMax;
    },
    getDateValueFormat() {
      // Convert the current period to UPPER CASE
      const period = this.period.toUpperCase();
      return DEFAULT_DATE_FORMATS[period];
    },
    getPeriodColumnTitle() {
      return PERIOD_COLUMN_TITLES[this.period];
    },
    period_pager: {
      get() {
        return this.periodTable.period_page;
      },
      set(_) {
        this.$store.dispatch('searchFunnelIncrementPeriodPage');
        this.$emit('refresh');
      }
    }
  },
  methods: {
    getDescriptionBasedOnKpiKey,
    getColorsBasedOnRange,
    handleDateClick(period) {
      period = moment(period);
      this.$emit("setDateRange", period);
    },
    handleDateReset() {
      this.$emit("setDateRange", null);
    },
    handleRowClick(item) {
      this.handleRowClicked(item, this.handleDateReset, this.handleDateClick, 'period_agg');
    }
  }
};